import { useEffect, useState } from "react";
import { cn } from "~/lib/utils";

import { ErrorProps, FormError } from ".";
import AddUserTag, { AddUserProps } from "../shared/user-lists/add-user";

interface Props {
  label: string;
  required?: boolean;
  errors?: ErrorProps;
  onChange: (option: AddUserProps[] | []) => void;
  value: AddUserProps[];
  className?: string;
  title?: string;
}

export default function FormExternalInput({
  label,
  errors,
  value,
  onChange,
  className,
  title,
}: Props) {
  const [users, setUsers] = useState<AddUserProps[]>(value ?? []);
  useEffect(() => {
    onChange(users);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users]);
  return (
    <div>
      <div className="w-full">
        <div className="pb-4">
          <span className="text-lg font-medium">{label}</span>
        </div>
        <div
          className={cn(
            "rounded-md border border-neutral-300 bg-white px-3 py-2.5",
            className,
          )}
        >
          <AddUserTag title={title} userLists={users} setUserLists={setUsers} />
        </div>
        <FormError error={errors?.error} message={errors?.message} />
      </div>
    </div>
  );
}
